import Cookies from 'js-cookie';

import { listCredentialNames, removeCredential } from './credentialsStorage';

/**
 * Clears every credential, keeping only the trusted device.
 *
 * Sweeps BOTH layers independently. `Cookies.get()` comes back empty inside a
 * cross-site iframe — where the browser drops cookies — so relying on it alone would
 * leave the storage mirror untouched and the expired credential would be resurrected
 * on the next read. `listCredentialNames()` covers exactly that case.
 */
export const clearCookiesExceptTrustedDevice = (): void => {
  const allCookies = Cookies.get();

  Object.keys(allCookies).forEach((cookieName) => {
    if (cookieName.includes('trusted_device')) {
      return;
    }

    Cookies.remove(cookieName, { path : '/', domain : '.ingresse.com' });
    Cookies.remove(cookieName, { path : '/' });
    Cookies.remove(cookieName);
  });

  listCredentialNames().forEach((credentialName) => {
    if (credentialName.includes('trusted_device')) {
      return;
    }

    removeCredential(credentialName);
  });
};
